"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEmbeddableSsmlForEdgeSilence = void 0;
// Helper to convert break time to milliseconds
const convertBreakTimeToMs = (time, unit) => {
    const value = parseFloat(time);
    switch (unit) {
        case "s":
            return value * 1000;
        case "ms":
            return value;
        default:
            throw new Error(`Unsupported time unit: ${unit}`);
    }
};
// Helper to parse break tag
const parseBreakTag = (tag) => {
    const match = tag.match(/<break time="(\d+\.?\d*)(ms|s)"/);
    if (!match)
        return null;
    return {
        fullMatch: match[0],
        time: match[1],
        unit: match[2]
    };
};
/**
 * Parses an embeddable SSML string for leading and trailing edge silence.
 * It only supports text created by the EmbeddableSsml class, so only <break> tags are considered.
 * @param ssml the ssml as a string
 */
const parseEmbeddableSsmlForEdgeSilence = (ssml) => {
    // Handle empty or whitespace-only input
    if (!ssml.trim()) {
        return { ssml: "" };
    }
    let result = { ssml: ssml };
    // Check for leading break
    const leadingBreakMatch = result.ssml.match(/^\s*<break time="(\d+\.?\d*)(ms|s)"\s*\/>\s*/);
    if (leadingBreakMatch) {
        const breakMatch = parseBreakTag(leadingBreakMatch[0]);
        if (breakMatch) {
            result.leadingSilence = convertBreakTimeToMs(breakMatch.time, breakMatch.unit);
            result.ssml = result.ssml.slice(leadingBreakMatch[0].length);
        }
    }
    // Check for trailing break
    const trailingBreakMatch = result.ssml.match(/\s*<break time="(\d+\.?\d*)(ms|s)"\s*\/>\s*$/);
    if (trailingBreakMatch) {
        const breakMatch = parseBreakTag(trailingBreakMatch[0]);
        if (breakMatch) {
            result.trailingSilence = convertBreakTimeToMs(breakMatch.time, breakMatch.unit);
            result.ssml = result.ssml.slice(0, -trailingBreakMatch[0].length).trim();
        }
    }
    return result;
};
exports.parseEmbeddableSsmlForEdgeSilence = parseEmbeddableSsmlForEdgeSilence;
//# sourceMappingURL=ssmlParser.js.map